import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PlanList from "../../Components/PlanList";
import sal from "sal.js";
import AllFeatures from "../../Components/AllFeatures";
import { Helmet } from "@dr.pogodin/react-helmet";
import MinPlanPrice from "../../Components/MinPlanPrice";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import CouponScrollBar from "../../Components/CouponScrollBar";
import StreamingServerVideo from "../../Components/StreamingServerVideo";

export default function StreamingServerNewYork() {
  const [applyPaddingClass, setApplyPaddingClass] = useState(false);
  useEffect(() => {
    document.title = "Streaming Server Montreal – Reliable & Fast Hosting Solution";
          sal();
      }, []);
  const handlePlanClick = () => {
     ScrollToPlans(".price-plan-section");
   };
  return (
    <>
    <Helmet>
        <title>Streaming Server Montreal – Reliable & Fast Hosting Solution</title>
        <meta name="description" content="Get a high-performance streaming server montreal with low latency, smooth live streaming, and reliable bandwidth for OTT, gaming, and media platforms worldwide." />
        <meta name="keywords" content="Web Streaming Service, Streaming server new york, Personal Streaming Service, Best Streaming Server, Streaming Server Cost, Best Server For Streaming, Best Stream Server, Live Streaming Server, Open Streaming Server, Self Hosted Streaming, Server For Streaming Media, Server Streaming Open Source, Set Up A Streaming Server, Streaming Server Hosting Cost, Streaming Server Hosting, Media Streaming Server, Stream Server, Streaming Server Windows, Live Stream Server, Streaming Web Server, Web Server Streaming, Streaming-Server, Vod Server" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/streaming-server-new-york`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/streaming-server-new-york`} />
        <meta property="og:title" content="Best Streaming Server in New York: High Quality Hosting" />
        <meta property="og:description" content="Discover the ideal streaming servers in New York for seamless, HD content delivery, etc. Ideal for organizations wanting low-latency, high-bandwidth hosting." />
    </Helmet>
    <section className="banner banner-security bg-dark control-panel-banner left-to-right-tilt-banner special-tilt-pb">
          <div className="container">
              <div className="row align-items-center">
                  <div className="col-lg-7 col-xl-6">
                      <span className="fs-18 fw-semibold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                          Lights. Stream. Action.
                      </span>
                      <h1 className="text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        Lights, Camera, No Glitch: With Streaming Server New York
                      </h1>
                      <p className="mb-8 text-white max-text-72 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                          Lights on. Camera set. Mic check. Vibe set. Oh nooo-buffering again? Nah, not anymore, not in New York. Our streaming server New York brings the fire with seamless, high-speed content delivery that always keeps your content engaging.
                      </p>
                      <div className="d-flex align-items-center gap-5 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                            <span className="btn-arrow__text">
                                Get Started
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </button>
                        <MinPlanPrice category="customizedssny" />
                      </div>
                      <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                  </div>
                  <div className="col-lg-5 col-xl-6 text-lg-end ipad-mt">
                      <img src="images/lights-camera-no-glitch.webp" alt="image" className="img-fluid sal-animate full-width-img" data-sal="fade" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" />
                  </div>
              </div>
          </div>
      </section>
      <section className="domain-container position-relative z-1 overflow-hidden special-domain-container">
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-xl-10">
                          <div className="card cta-wrapper-one rounded-4 domain-container-inner">
                              <div className="card-body pt-60 pb-60">
                                  <div className="row justify-content-center">
                                    <div className="col-md-11 col-lg-10 col-xl-10">
                                        <div className="text-center">
                                          <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Budget-Friendly Solutions</span>
                                            <h4 className="mb-4">
                                                Streaming Feels Costly? Not with This Live Streaming Server New York
                                            </h4>
                                            <p className="mb-6">
                                              Say bye-bye to buffering and high prices. With the help of our live streaming server New York, you get even video/audio streaming, 24/7 support, and exclusive performance-without breaking the bank.
                                            </p>
                                            <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2 btn-height">
                                                <span className="d-inline-block me-1 flex-shrink-0">
                                                    <i className="las la-comments"></i>
                                                </span>
                                                <span className="btn-arrow__text">
                                                    +91-7737300013
                                                    <span className="btn-arrow__icon">
                                                        <i className="fa-solid fa-arrow-right"></i>
                                                    </span>
                                                </span>
                                            </Link>
                                            <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded ms-sm-2 mt-sm-0 mt-4 open-live-chat btn-height">
                                                <span className="d-inline-block me-1 flex-shrink-0">
                                                    <i className="las la-comments"></i>
                                                </span>
                                                <span className="btn-arrow__text">
                                                    Talk to an Expert
                                                    <span className="btn-arrow__icon">
                                                        <i className="fa-solid fa-arrow-right"></i>
                                                    </span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
      </section>

      <div className="pt-100 pb-100 linux-hosting-points-section">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center justify-content-xl-between">
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Midtown Media Flow
                        </small>
                        <h2 className="mb-4">
                            Say Byeeee to “Can You See Me?” Moments Forever
                        </h2>
                        <p className="max-text-56 mb-0 fw-semibold">
                            Crossed fingers and constantly dropping stream viewers? No, not anymore. Dedicated Streaming Server New York always keeps your livestream completely relaxed and fully in control.
                        </p>
                    </div>
                    <div className="col-lg-6 col-xl-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="card">
                            <div className="card-body">
                                <div className="features-video position-relative z-1"><img alt="image" className="img-fluid w-100" src="/images/streaming-server-yt-banner.jpg" /><Link to="#" className="btn gradient-bg w-15 h-15 d-grid place-content-center rounded-circle position-absolute top-50 start-50 translate-middle fs-24 text-white popup-init" data-bs-toggle="modal" data-bs-target="#streamingServerVideoModal"><i className="fa-solid fa-play"></i></Link></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="row g-4">
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/stream-on-your-terms.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                Stream on Your Terms
                            </h6>
                            <p className="mb-0">
                                Ranging from server setup to scale, your live streaming server stays in sync with your goals.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/in-your-hands.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                In Your Hands, Always
                            </h6>
                            <p className="mb-0">
                                Stream anywhere, on any type of device-with the power of a dedicated streaming server.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/big-city-high.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                Big City. High Uptime.
                            </h6>
                            <p className="mb-0">
                                No more glitches, no more buffering, just smooth streaming with our New York server.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>

      <section className="price-plan-section pt-100 pb-100">
          <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
          <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-xl-8">
                          <div className="text-center">
                              <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                              <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> One Plan. All Yours.</h2>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        <PlanList category={'customizedssny'}/>
      </section>

     <section className="pt-100 pb-100">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Stream NYC
                        </small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Exciting Features of Our New York Streaming Server Plans</h2>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Fast Starts, Smooth Streams</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/fast-starts-smooth.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Don’t let a slow server ruin your flow. With the help of an easy UI, clean CLI, and scalable API, our streaming server New York, lets you launch.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">No Lag. Just Live.</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/no-lag-just.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Go live & stay in sync. With Infinitive Host’s reduced latency WebRTC streaming, your audience experiences the moment as it waits for it.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Big Audiences. No Meltdowns.</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/big-audiences.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Infinitive Host’s WebRTC clusters scale with your target audience-streaming stays seamless with just 0.05s latency. No lag, nothing.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Protected in Seconds</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">04</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/protected-in.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Your stream stays secured with our robust DDoS shield-blocking floods and all attacks within 10 seconds. No downtime, just uptime.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Make Every Call Count</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">05</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/make-every.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Integrate both real-time video and audio calls into your application with our easy SDKs-fast to plug in and engineered to connect.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Watch Live, Anytime</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">06</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/live-in-hours.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Stream IP camera feeds on your application or website along with AMS-instant setup, ONVIF-ready, and audio-powered for live monitoring.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section className="bg-dark pt-100 pb-100 position-relative allfeatures-wrapper">
        <img src="images/service_16_shape_2.png" alt="Image" className="img-fluid position-absolute start-0 bottom-0 pattern-bg-img"></img>
        <div className="pb-40">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-10 col-lg-8 col-xl-7">
                        <div className="text-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                          <span className="section-title-dark style-bg fadeInUp">Key Characteristics</span>
                            <h2 className="text-white">
                                Our New York Server Makes You Viral,Unexpectedly.
                            </h2>
                            <p className="mb-0 text-white max-text-52 mx-auto text-opacity-75">
                                Buffering ruins the perfect moment. Perks of our streaming dedicated server New York always keep your content flowing and your audience engaged.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AllFeatures />
      </section>

      

    <section className="pt-100 pb-100">
      <div className="">
        <div className="container">
          <div className="card cta-wrapper-one domain-container-inner rounded-3 mb-5">
            <div className="card-body p-md-6 special-box-padding p-xl-10">
              <div className="g-4 align-items-center">
                <div className="text-center">
                <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span> Streaming On All Screens</small>
                  <h5 className="mt-3 mb-4">
                      Behind the Stream: How Everything Works Smoothly
                  </h5>
                  <p className="">
                      No challenging setup. No downtime issue. Our dedicated streaming servers are completely prepped and enhanced, so you can go live in no time. With full HD quality and no lag, your target audience experiences a smooth, trustworthy stream viewing experience-no matter what device they are using.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 pt-60">
              <img src="images/behind-the-scene-streaming.webp" alt="image" className="img-fluid" />
          </div>
        </div>
      </div>
    </section>

    <section className="pb-100">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>NY Streaming Hub
                        </small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Our Streaming Server New York Is The Whole Point.</h2>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 p-xl-10 rounded-3">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Fast Launch, No Fees</h6>
                            <p className="h5 mb-0 text-white text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/fast-just-got-faster.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Start your stream with no setup fee-just a single click & see you are live.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Always-On Support</h6>
                            <p className="h5 mb-0 text-white text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/support-never.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">24/7 support that replies without delay-no more unnecessary waiting.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Limit-Free Streams</h6>
                            <p className="h5 mb-0 text-white text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/locked-down.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">It doesn’t matter if it’s 100 or 10,000 audience-your stream scales.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Secured to the Core</h6>
                            <p className="h5 mb-0 text-white text-opacity-25">04</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/control-like.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Stay protected from malware and others-your stream stays secure.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Doubt-Free Reliability</h6>
                            <p className="h5 mb-0 text-white text-opacity-25">05</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/smarter-configs.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Your stream, your website, your applications-always on, always stable.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Backups on Autopilot</h6>
                            <p className="h5 mb-0 text-white text-opacity-25">06</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/backup-game.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Week or month-we always keep your data protected and go-ready.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>

        <div className="pt-40 pb-100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-10 col-lg-8 col-xl-6">
                        <div className="text-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Stream Never Sleeps</small>
                            <h2 className="mb-4">
                                It’s High Time to Stream in HD
                            </h2>
                            <p className="mb-8 max-text-52 mx-auto sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Level Up or Lag Out! It’s Up to You–Streaming Server New York Got You
                            </p>
                            <div className="d-flex flex-wrap justify-content-center align-items-center gap-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <Link to="#" onClick={handlePlanClick} className="btn btn-lg btn-primary btn-arrow fs-14 fw-medium rounded btn-height">
                                    <span className="d-inline-block me-1 flex-shrink-0">
                                        <i className="las la-comment-dots"></i>
                                    </span>
                                    <span className="btn-arrow__text">
                                        Get Started
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                                </Link>
                                <Link to="#" className="btn btn-lg btn-dark btn-arrow fs-14 fw-medium rounded open-live-chat btn-height">
                                    <span className="d-inline-block me-1 flex-shrink-0">
                                        <i className="las la-comment-dots"></i>
                                    </span>
                                    <span className="btn-arrow__text">
                                        Talk to an Expert
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <StreamingServerVideo />
    </>
  );
}
